import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

const initialState = {
    sort: '',
    all: true,
};

export const filterSlice = createSlice({
    name: 'filter',
    initialState,

    // The `extraReducers` field lets the slice handle actions defined elsewhere,
    // including actions generated by createAsyncThunk or in other slices.
    reducers: {
        addSort: (state, action) => {
            state.sort = action.payload
        },
        changeFilter: (state, action) => {
            state.all = action.payload
        },
    }
});


// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)` 
export const { addSort, changeFilter } = filterSlice.actions;
export default filterSlice.reducer;

